import { render, staticRenderFns } from "./modal-notice.vue?vue&type=template&id=2a5a68fe&scoped=true"
import script from "./modal-notice.vue?vue&type=script&lang=js"
export * from "./modal-notice.vue?vue&type=script&lang=js"
import style0 from "./modal-notice.vue?vue&type=style&index=0&id=2a5a68fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a68fe",
  null
  
)

export default component.exports